module.exports = {
    borderRadiusSmall: '4px',
    borderRadius: '8px',
    borderRadiusLarge: '16px',
};
